import { render, staticRenderFns } from "./AccountTemplate.vue?vue&type=template&id=0e39f293"
import script from "./AccountTemplate.vue?vue&type=script&lang=js"
export * from "./AccountTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../gd-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports